var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16656 21.4106H7.58323V22.5012H2.16656V21.4106Z",
    fill: "#17253F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 21.4106H23.8333V22.5012H12.9999V21.4106Z",
    fill: "#17253F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8332 6.2512H10.2916V5.16064H23.8332V6.2512Z",
    fill: "#17253F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8749 6.2512H2.16656V5.16064H4.8749V6.2512Z",
    fill: "#17253F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8333 14.3762H19.4999V13.2856H23.8333V14.3762Z",
    fill: "#17253F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0832 14.3762H2.16656V13.2856H14.0832V14.3762Z",
    fill: "#17253F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58326 3.54295C6.38864 3.54295 5.42021 4.51138 5.42021 5.706C5.42021 6.90062 6.38864 7.86906 7.58326 7.86906C8.77788 7.86906 9.74632 6.90062 9.74632 5.706C9.74632 4.51138 8.77788 3.54295 7.58326 3.54295ZM4.32965 5.706C4.32965 3.90908 5.78634 2.45239 7.58326 2.45239C9.38018 2.45239 10.8369 3.90908 10.8369 5.706C10.8369 7.50292 9.38018 8.95961 7.58326 8.95961C5.78634 8.95961 4.32965 7.50292 4.32965 5.706Z",
    fill: "#17253F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7916 11.6679C15.597 11.6679 14.6285 12.6364 14.6285 13.831C14.6285 15.0256 15.597 15.9941 16.7916 15.9941C17.9862 15.9941 18.9546 15.0256 18.9546 13.831C18.9546 12.6364 17.9862 11.6679 16.7916 11.6679ZM13.538 13.831C13.538 12.0341 14.9947 10.5774 16.7916 10.5774C18.5885 10.5774 20.0452 12.0341 20.0452 13.831C20.0452 15.6279 18.5885 17.0846 16.7916 17.0846C14.9947 17.0846 13.538 15.6279 13.538 13.831Z",
    fill: "#17253F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2916 19.7929C9.09695 19.7929 8.12852 20.7614 8.12852 21.956C8.12852 23.1506 9.09695 24.1191 10.2916 24.1191C11.4862 24.1191 12.4546 23.1506 12.4546 21.956C12.4546 20.7614 11.4862 19.7929 10.2916 19.7929ZM7.03796 21.956C7.03796 20.1591 8.49466 18.7024 10.2916 18.7024C12.0885 18.7024 13.5452 20.1591 13.5452 21.956C13.5452 23.7529 12.0885 25.2096 10.2916 25.2096C8.49466 25.2096 7.03796 23.7529 7.03796 21.956Z",
    fill: "#17253F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.9dac726d.svg";
export { ForwardRef as ReactComponent };